



















import Vue, { PropType } from "vue";
import "@/components/icons";
import PlanFloatingView from "../PlanFloatingView/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "UpdatePlanFloatingView",
  components: {
    PlanFloatingView
  },
  props: {
    availableGraduateYears: {
      type: Array as PropType<Props["availableGraduateYears"]>,
      required: true
    },
    initialId: {
      type: Number,
      required: true
    },
    initialGraduateYear: {
      type: String,
      required: true
    },
    initialName: {
      type: String,
      required: true
    },
    messages: {
      type: Array as PropType<Props["messages"]>,
      required: true
    }
  },
  data() {
    return {
      updatePlan: {
        id: this.initialId,
        name: this.initialName,
        graduateYear: Number(this.initialGraduateYear)
      }
    };
  },
  computed: {
    disabledSubmitButton() {
      // TODO: 仕様書の完了条件に合わせて編集されていない場合は非活性化とする
      return this.updatePlan.name === this.initialName;
    }
  },
  methods: {
    handleInputGraduateYear(graduateYear) {
      this.updatePlan.graduateYear = Number(graduateYear);
    },
    handleChangeName(name) {
      this.updatePlan.name = name;
    },
    handleClickSubmit() {
      this.$emit("submit", this.updatePlan);
    },
    handleClickCancel() {
      this.$emit("cancel");
    },
    handleClickDelete() {
      this.$emit("delete");
    }
  }
});
